import { AssociationNanoIDsFilter, NanoID } from '../../../../../types';

export const enum UniversalFilterCompaniesModes {
  CONTAINS_ANY_OF = 'contains_any_of'
}

export type UniversalFilterCompaniesValue = AssociationNanoIDsFilter;

export type UniversalFilterCompaniesFilterState = {
  mode: UniversalFilterCompaniesModes;
  companyNanoIds?: NanoID[];
};

export type UniversalFilterCompaniesOnFilterStateChange = (
  state: UniversalFilterCompaniesFilterState
) => void;

export type UniversalFilterCompaniesOnChange = (
  value?: UniversalFilterCompaniesValue
) => void;
